//Custom components

import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import StatCard from '../../../UI/Card/StatCard';

const ValueOfProposedProjectsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Value of Proposed Projects' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default ValueOfProposedProjectsWidget;
